<template>
  <svg :width="width" :height="height" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="14" cy="14" r="10.3125" stroke="#9AA4AE" stroke-width="1.375" class="border"/>
    <circle cx="14" cy="11.7084" r="2.97917" :stroke="fill" stroke-width="1.375"/>
    <path d="M6.66663 21.3333C7.98721 18.0775 10.7748 15.8333 14 15.8333C17.2252 15.8333 20.0127 18.0775 21.3333 21.3333" :stroke="fill" stroke-width="1.375"/>
  </svg>

</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  props: {
    width: {
      default: 28,
    },
    height: {
      default: 28,
    },
    fill: {
      default: "currentColor",
    },
    viewBox: {
      default: "0 0 28 28",
    },
    disabled: {
      default: false,
    },
  },
})
</script>
